import { useDispatch } from 'react-redux';
import { MenuItem, Typography, useTheme } from '@mui/material';
import { userModel } from 'entities/user';
import { Chains, Icon, useShallowSelector } from 'shared';
import { useWalletConnectorContext } from 'shared/config/wallet-connect';

import { MenuItemsProps, Selector } from '../../../../../shared/ui/Selector';

export const HeaderChainSelector = () => {
  const { network, provider } = useShallowSelector(userModel.selectors.selectUserWeb3Info);
  const { disconnect, connect } = useWalletConnectorContext();
  const theme = useTheme();
  const dispatch = useDispatch();

  const handleSwitchNetwork = async (chain: Chains) => {
    if (network !== chain) {
      disconnect(false);
      dispatch(userModel.userActions.updateUserState({ network: chain }));
      await connect(provider, chain);
    }
  };

  const ChainsItems: React.FC<MenuItemsProps<Chains>> = ({ onSelect }) =>
    Object.values(Chains).map((value) => (
      <MenuItem key={value} onClick={() => onSelect(value)}>
        <Icon type={value} size={42} />
        <Typography variant="button" sx={{ ml: '10px' }}>
          {value}
        </Typography>
      </MenuItem>
    ));

  return (
    <Selector<Chains>
      MenuItems={ChainsItems}
      onSelect={handleSwitchNetwork}
      selectedIcon={network}
      selectedText={network}
      menuProps={{
        slotProps: {
          paper: {
            sx: {
              width: { xs: '100%', md: 328 },
            },
          },
        },
        sx: {
          '.MuiBackdrop-root': { background: { xs: theme.themeColors.colorMenuBackdrop, md: 'transparent' } },
        },
      }}
    />
  );
};
